import { useTranslation } from 'react-i18next'
import { CheckCircle2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * Nội dung toast "Đã xong bước N — Quay lại trang Bắt đầu" (dùng với `toast.custom`): hai nút xếp riêng một hàng
 * để không bị bó chữ như toast mặc định có cả `action` lẫn `cancel`.
 */
export function OnboardingDoneToast({
  title,
  note,
  onBack,
  onStay,
}: {
  title: string
  note?: string
  onBack: () => void
  onStay?: () => void
}) {
  const { t } = useTranslation('sharedMisc')
  return (
    <div className="w-[356px] max-w-[calc(100vw-2rem)] rounded-lg border border-success/30 bg-card p-4 text-card-foreground shadow-lg">
      <div className="flex gap-3">
        <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-success" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium">{title}</p>
          <p className="mt-0.5 text-xs text-muted-foreground">{note ?? t('onboardingDoneToast.defaultNote')}</p>
          <div className="mt-3 flex flex-wrap gap-2">
            <Button size="sm" onClick={onBack}>
              {t('onboardingDoneToast.backToOnboarding')}
            </Button>
            {onStay && (
              <Button size="sm" variant="ghost" onClick={onStay}>
                {t('onboardingDoneToast.stayHere')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
